export class Pillar {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {
    return {
      title: this.fields.attributes.title,
      description: this.fields.attributes.field_pillar_description.processed,
      heroImage: this.getRelationshipValue('field_pillar_hero'),
      cardImage: this.getRelationshipValue('field_pillar_card'),
      category: this.getRelationshipValue('field_pillar_term')
    };
  }

  getRelationshipValue(field) {
    const rel = this.fields.attributes.relationships.find((i) => i.field === field);

    return rel
      ? rel.value
      : null;
  }
}
